module.exports = __webpack_public_path__ + "src/assets/img/cmd-pre-heater-start.f92e5113.svg";